/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/games/filter': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M10 20h80M10 50h80M10 80h80"/><circle pid="1" class="circle-1" cx="30" cy="20" r="10"/><circle pid="2" class="circle-2" cx="70" cy="50" r="10"/><circle pid="3" class="circle-1" cx="30" cy="80" r="10"/>'
  }
})
